import { http } from '../http';

export type QueriesType = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  page?: number;
  originating_portal_user_ids?: Array<string>;
};

type ServerResponse = {
  agent_quotes: Array<{
    id: string;
    quote_number: string;
    resume_link: string;
    quote_pdf_link: string | null;
    attribution_link_id: string;
    primary_driver: {
      first_name: string | null;
      last_name: string | null;
      birth_date: string | null;
    };
    contact_information: {
      email: string | null;
      phone: {
        type: string | null;
        number: string | null;
        extension: string | null;
      };
    };
    application: {
      state: string;
    };
    policy_information: {
      state: string | null;
      zip_code: string | null;
      one_inc_policy_id: string | null;
      system_of_record: string | null;
    };
    partner: {
      name: string | null;
    };
    updated_at: string;
    created_at: string;
  }>;
  total: number | null;
};

export type QuoteSearchResults = {
  agentQuotes: Array<{
    id: string;
    quoteNumber: string;
    status: string;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    birthDate: string | null;
    phone: string | null;
    createdAt: string | null;
    resumeLink: string;
    quotePdfLink: string | null;
    updatedAt: string | null;
    zipCode: string | null;
    state: string | null;
    producer: string | null;
    oneIncPolicyId: string | null;
    systemOfRecord: string | null;
    attributionLinkId: string;
  }>;
  total: number | null;
};

export const postSearch = (token: string, queries: QueriesType = {}) => {
  const payload: QueriesType = Object.keys(queries).reduce((payload, key) => {
    const queryKey = key as keyof typeof queries;

    return !!queries[queryKey]
      ? {
          ...payload,
          [queryKey]: queries[queryKey],
        }
      : payload;
  }, {});

  return http
    .post<QuoteSearchResults>(
      {
        url: '/api/agent_services/search',
        token,
        transformResponse: (
          jsonData: string | ServerResponse
        ): QuoteSearchResults => {
          const data: ServerResponse =
            typeof jsonData == 'string' ? JSON.parse(jsonData) : jsonData;
          return {
            agentQuotes: data.agent_quotes.map(q => ({
              id: q.id,
              quoteNumber: q.quote_number,
              status: q.application.state,
              email: q.contact_information.email,
              phone: q.contact_information.phone.number,
              firstName: q.primary_driver.first_name,
              lastName: q.primary_driver.last_name,
              birthDate: q.primary_driver.birth_date,
              createdAt: q.created_at,
              resumeLink: q.resume_link,
              quotePdfLink: q.quote_pdf_link,
              updatedAt: q.updated_at,
              zipCode: q.policy_information.zip_code,
              state: q.policy_information.state,
              producer: q.partner.name,
              oneIncPolicyId: q.policy_information.one_inc_policy_id,
              systemOfRecord: q.policy_information.system_of_record,
              attributionLinkId: q.attribution_link_id,
            })),
            total: data.total,
          };
        },
      },
      payload
    )
    .catch(error => error.response);
};
